const textStyles = {
  "display-large": {
    fontFamily: "Eczar",
    fontWeight: "700",
    fontSize: "3.625rem",
    lineHeight: "100%",
  },
  "display-medium": {
    fontFamily: "Eczar",
    fontWeight: "700",
    fontSize: "3rem",
    lineHeight: "100%",
  },
  "header-large": {
    fontFamily: "Work Sans",
    fontWeight: "700",
    fontSize: "2.5rem",
    lineHeight: "110%",
  },
  "header-medium": {
    fontFamily: "Work Sans",
    fontWeight: "700",
    fontSize: "2rem",
    lineHeight: "125%",
  },
  "title-large": {
    fontFamily: "Work Sans",
    fontWeight: "500",
    fontSize: "1.75rem",
    lineHeight: "125%",
  },
  "title-medium": {
    fontFamily: "Work Sans",
    fontWeight: "500",
    fontSize: "1.5rem",
    lineHeight: "125%",
  },
  "title-small": {
    fontFamily: "Work Sans",
    fontWeight: "500",
    fontSize: "1.125rem",
    lineHeight: "150%",
  },
  "body-large": {
    fontFamily: "Work Sans",
    fontWeight: "400",
    fontSize: "1.125rem",
    lineHeight: "150%",
  },
  "body-medium": {
    fontFamily: "Work Sans",
    fontWeight: "400",
    fontSize: "1rem",
    lineHeight: "150%",
  },
  "button-medium": {
    fontFamily: "Work Sans",
    fontWeight: "600",
    fontSize: "1rem",
    lineHeight: "100%",
  },
  "button-small": {
    fontFamily: "Work Sans",
    fontWeight: "600",
    fontSize: "0.75rem",
    lineHeight: "100%",
  },
  label: {
    fontFamily: "Work Sans",
    fontWeight: "600",
    fontSize: "0.75rem",
    lineHeight: "100%",
  },
};

export default textStyles;
